// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JAOP","icon":"styles_icon__2byiO"};